<template>
  <a-row style="height: 100%">
    <a-col :span="24">
      <a-row class="max1200">

        <a-row class="search-header">
          <slot name="header"></slot>
        </a-row>

        <slot name="content">
        </slot>

        <a-row class="load-more">
          <slot name="loadmore">
          </slot>
        </a-row>

      </a-row>
    </a-col>
    <a-col :span="24" style="z-index: 10">
      <slot name="relation">
      </slot>
    </a-col>
  </a-row>
</template>

<script>
export default {
    name: 'BasicLayout',
}
</script>

<style scoped>

  .max1200 {
      max-width: 1200px;
      margin: auto;
      height: 100%;
      padding: 0px 8px;
  }
  .search-header {
    margin-top: 8px;
    border-right: 1px solid #d1d5da;
    border-left: 1px solid #d1d5da;
    border-top: 1px solid #d1d5da;
    border-radius: 3px 3px 0px 0px;
  }
  .load-more {
    padding: 16px 0px 0px 0px;
  }
  .border-all {
    border-bottom: 1px solid #d1d5da;
    border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
  }
</style>
